<div id="main-page-wraper" class="main-page-wraper relative " style="max-width: 100dvw;">

  <div class=" flex flex-wrap justify-start">


 
    <app-sidebar [expanded]="sidebarOpen" style="z-index: 998;"></app-sidebar>




    <div
      class="layout-main-section flex flex-col justify-between duration-200 w-full relative {{isMobile ? 'layout-mobile content-mobile' : sidebarOpen  ? 'content-desktop' : 'content-desktop-expanded'}}"
      id="main-content">

      <div class="h-full">
        <div @opacity *ngIf="!sidebarOpen && isMobile" (click)="this.closeSidebar()" style="z-index: 997;"
          class="disable-working-area fixed bg-primary-950/80 w-full text-white will-change-auto">
          <div class="w-full h-full flex justify-between items-center">
            <div style="width: 300px!important;  transform: translateX(0); min-width: 300px; max-width: 300px;"></div>
            <div class="flex flex-col text-center w-full">

              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="w-auto">
                <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                <path d="M18 6l-12 12" />
                <path d="M6 6l12 12" />
              </svg>
              <p>Chiudi</p>
            </div>
          </div>
        </div>
        @if(!initialLoad){
        <div class="layout-header">

          <app-header @fadeInOutWithBlur></app-header>
        </div>

        <div class="flex justify-start items-center gap-2 overflow-auto hide-scrollbar w-full p-2 px-4">
          

          <app-bread-crumbs></app-bread-crumbs>
        </div>



        <!-- <div @fadeInOutWithBlur #contentView id="layout-main-second" class="layout-main-second">

        <router-outlet @fadeInOutWithBlur></router-outlet>

      </div>

      <div @fadeInOutWithBlur class="layout-footer-section">
        <app-footer></app-footer>
      </div> -->

        <div @fadeInOutWithBlur #contentView id="layout-main-second">

          <div class="h-full">
            <router-outlet></router-outlet>
          </div>

        </div>

        }@else {
        <div @fadeInOutWithBlur
          class="layout-main-second h-screen w-screen fixed top-0 left-0 flex flex-col justify-center items-center backdrop-blur-xl">


          <app-loading-animation></app-loading-animation>
        </div>
        }

      </div>
      <div>

        <app-footer></app-footer>
      </div>
    </div>
  </div>


</div>